module.exports = __webpack_public_path__ + "img/icon_donaciones.2552c930.svg";